/**
 * Format: Collection
 * ------------------------------------------------------------------------------
 * - Format a collection response from the Storefront API
 * - Outputted object should match that of the formatted Shopify API helper.
 * - https://shopify.dev/docs/api/storefront/2023-07/objects/Collection
 */
import { formatProduct } from '~/format/product'
import { decodeApiId, transformEdges } from '~/helpers/graphql'

/**
 * Formats response from collection.
 * @param {Object} response - GraphQL Storefront response.
 * @returns {Boolean|Object}
 */
export function formatCollection(response) {
  const { collection } = response

  if (!collection) {
    return false
  }

  const handle = collection.handle

  const url = mint.routes.root === '/'
    ? `//${location.host}/collection/${handle}`
    : `//${location.host}${mint.routes.root}/collection/${handle}`

  const formattedCollection = {
    handle,
    id: decodeApiId(collection.id),
    pageInfo: collection?.products?.pageInfo,
    title: collection.title,
    url,
  }

  formattedCollection.products = transformEdges(collection.products)
    .map(responseProduct => formatProduct({ responseProduct }))

  return formattedCollection
}